<!--
* @description  参数1
* @fileName  addressEdit
* @author userName
* @date 2024-01-02 14:56:30
!-->
<template>
  <div id="addressEdit" class="addressEdit">
    <DialogEidt :value="isShow" @close="closeDialog">
      <template v-slot:title>
        <div>{{ formData.id?'修改信息':'新增信息' }}</div>
      </template>
      <template v-slot:body>
        <div class="main-info p24 check-price-form">
          <el-form ref="elForm" :model="formData" :rules="allRules" label-position="top" size="medium"
            class="item-Surcharge" @submit.native.prevent>
            <div class="new_inquiry_header item-Surcharge_search">
              <el-form-item class="flex-width_1" prop="name" label="姓名">
                <el-input v-model="formData.name" />
              </el-form-item>
              <el-form-item class="flex-width_1" prop="tel" label="电话">
                <el-input v-model="formData.tel" />
              </el-form-item>
              <el-form-item class="flex-width_1" prop="companyName" label="公司名称">
                <el-input v-model="formData.companyName" />
              </el-form-item>
              <el-form-item class="flex-width_1" prop="countryId" label="国家">
                <el-select v-model="formData.countryId" filterable :popper-append-to-body="false"
                  style="text-align: left;width: 100%;">
                  <el-option v-for="(item, index) in countryList" :key="index" :value="item.id"
                    :label="item.code+'-'+item.name" />
                </el-select>
              </el-form-item>
              <el-form-item class="flex-width_1" prop="provinceName" label="省州">
                <el-input v-model="formData.provinceName" />
              </el-form-item>
              <el-form-item class="flex-width_1" prop="cityName" label="城市">
                <el-input v-model="formData.cityName" />
              </el-form-item>
              <el-form-item class="flex-width_1" prop="townName" label="区域">
                <el-input v-model="formData.townName" />
              </el-form-item>
              <el-form-item class="flex-width_1" prop="address" label="联系地址">
                <el-input v-model="formData.address" />
              </el-form-item>
              <el-form-item class="flex-width_1" prop="zipCode" label="邮编">
                <el-input v-model="formData.zipCode" />
              </el-form-item>
            </div>
          </el-form>
        </div>
      </template>
      <template v-slot:footer>
        <div class="foot-class">
          <button class="cancel" @click="closeDialog">取消</button>
          <button class="save by-button--primary" :loading="btnLoading" @click="clickSave">保存</button>
        </div>
      </template>
    </DialogEidt>
  </div>
</template>

<script>
import DialogEidt from '../../../components/Dialog/Dialog.vue'
import request from '@/utils/request'
import {
  GetCountry
} from '../../../api/base.js'
import {
  getCookie
} from '@/utils/cookiejs'
export default {
  name: 'addressEdit',
  components: {
    // 组件的引用
    DialogEidt
  },
  props: {
    // 父辈向子辈传参
    isShow: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  data () {
    return {
      formData: {
        id: '',
        name: undefined,
        addrType: undefined,
        tel: undefined,
        companyName: undefined,
        countryId: undefined,
        provinceName: undefined,
        cityName: undefined,
        townName: undefined,
        address: undefined,
      },
      token: '',
      countryList: [],
      btnLoading: false,
      allRules: {
        name: [{
          required: true,
          message: '请输入联系人姓名'
        }],
        countryId: [{
          required: true,
          message: '请选择国家'
        }
        ],
        tel: [{
          required: true,
          message: '请输入联系手机'
        }
        ]
      }
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created () {
    // 实例被创建之后执行代码
    this.token = getCookie('token')
    if (this.token) {
      this.getCountry()
      this.getCustomerInfo()
    }
  },
  mounted () {
    // 页面进入时加载内容
  },
  methods: {
    getCountry () {
      GetCountry().then(res => {
        this.countryList = res.data
      })
    },
    closeDialog () {
      this.$emit('close', false)
    },
    init (id, addrType) {
      this.formData.id = id;
      this.formData.addrType = addrType;
      console.log(this.formData)
      if (id) {
        request({
          url: '/api/base/CstAddress/' + this.formData.id,
          method: 'GET',
          headers: {
            Authorization: this.token
          }
        }).then((res) => {
          this.formData = res.data
        })
      }
    },
    clickSave () {
      // 表单校验
      this.$refs['elForm'].validate((val) => {
        if (val) {
          this.btnLoading = true;
          if (this.formData.id) {
            request({
              url: '/api/base/CstAddress',
              method: 'PUT',
              data: this.formData,
              headers: {
                Authorization: this.token
              }
            }).then((res) => {
              this.$message({
                message: res.msg,
                type: 'success',
                duration: 1000,
                onClose: () => {
                  this.btnLoading = false
                  this.closeDialog()
                  this.$emit('refresh', true)
                }
              })
            }).finally(() => {
              this.btnLoading = false
            })
          } else {
            request({
              url: '/api/base/CstAddress',
              method: 'post',
              data: this.formData,
              headers: {
                Authorization: this.token
              }
            }).then((res) => {
              this.$message({
                message: res.msg,
                type: 'success',
                duration: 1000,
                onClose: () => {
                  this.btnLoading = false
                  this.closeDialog()
                  this.$emit('refresh', true)
                }
              })
            }).finally(() => {
              this.btnLoading = false
            })
          }
        }
      })
    }
  }
}
</script>
<style scoped lang='scss'>
::v-deep .dialog__header {
  text-align: left;
}

::v-deep .dialog__body {
  padding: 0;

  .el-form-item {
    margin-bottom: 0;

    .el-form-item__label {
      float: left;
    }
  }
}

::v-deep .el-form-item__error {
  display: block !important;
}

.foot-class {
  margin: 24px 0;
  padding-bottom: 24px;
  text-align: right;

  .cancel {
    width: 72px;
    height: 32px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #dddddd;
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #333333;
    margin-right: 16px;
    cursor: pointer;
  }

  .save {
    width: 72px;
    height: 32px;
    border-radius: 4px;
    cursor: pointer;
  }
}
</style>
